import React, {useMemo} from 'react';
import {getPrimitive} from '@tickchak/react-share/app';
import GenericPieChart from '../../../pages/realtime/components/genericPieChart/GenericPieChart';
import * as css from './VideoRatingPopup.css';
import {RatingChartProps} from './types';

export const GREEN_COLOR = getPrimitive('greens.green400');
export const RED_COLOR = getPrimitive('reds.red200');

function RatingChart({greenPercent, redPercent}: RatingChartProps) {
    const chartData = useMemo(() => {
        if (greenPercent === 0 && redPercent === 0) {
            return [{value: 1, color: '#CCCCCC'}];
        }
        const data: {value: number; color: string}[] = [];
        if (greenPercent > 0) {
            data.push({value: greenPercent, color: GREEN_COLOR});
        }
        if (redPercent > 0) {
            data.push({value: redPercent, color: RED_COLOR});
        }
        return data;
    }, [greenPercent, redPercent]);

    return (
        <css.chartContainer>
            <GenericPieChart
                data={chartData}
                dataKey="value"
                halfCircle={true}
                radius={{innerRadius: 24, outerRadius: 30}}
                paddingAngle={2}
                cornerRadius={4}
                inlineRect={
                    <css.chartLabel>
                        <css.chartPercent>{greenPercent}%</css.chartPercent>
                    </css.chartLabel>
                }
            />
        </css.chartContainer>
    );
}

export default RatingChart;
